module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAb1BMVEUAAAAgoP8fnv8dnP8Alf8fn/8foP8fn/8en/8goP8fn/8fn/8foP8foP8VlP8fn/8foP8fn/8cnf8gn/8dnv8foP8gn/8gn/8eoP8foP8gnv8en/8dnP8foP8gn/8goP8fn/8fn/8env8gn/8Wm/8lbbFXAAAAJXRSTlMA6nkPBcDmnHC5rP2lsAuIxJI1uk3j2KCXa2lVPvTyyceKTBgXOlNiVAAAAJJJREFUGNOt0EkOwyAQRNHygI3BgOc5c+5/xrRIywJlm7f8m5IKLPcQyt1YkNGFudNuW9fN6Q6ebY2qhTY1MVrUyrQZRTVRUh7lSbUWJE0smE1SAN+YgWVhXCTcA3KJYjNDCMxNFEWJqkIp/hz7n9hQFCjj9eeBYcAx2DPK6xvsdZHncZVkve7A9lvB7nt4PYP3Aep7CDargi0SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/HandleDelete.png
// module id = rmEJ
// module chunks = 104